import Vue from 'vue'
import Vuex from 'vuex'
import base from './modules/base'
import dayjs from 'dayjs'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    base,
  },
  state: {
    lastRefreshTime: null
  },
  mutations: {
    setLastRefreshTime(state, time) {
      state.lastRefreshTime = dayjs().valueOf()
    },
    resetLastRefreshTime(state, time) {
      state.lastRefreshTime = ''
    }
  }
})
